import { AdvancedSelect } from '@orobix/orobix-fe-components'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { USER_LEVEL, UserLevel } from '../definitions'
import { Settings } from '../types'

type SelectOption = {
  value: UserLevel
  label: string
}

interface UserlevelSelectorProps {
  label?: string
  settings?: Settings
  updateSettings?: (settings: Partial<Settings>) => void
  isLoading: boolean
}

const UserlevelSelector = ({
  label,
  settings,
  updateSettings,
  isLoading,
}: UserlevelSelectorProps) => {
  const { t } = useTranslation()

  const options = [
    { value: USER_LEVEL.basic, label: t('Basic') },
    { value: USER_LEVEL.expert, label: t('Expert') },
  ]

  const [value, setValue] = useState<SelectOption>()

  useEffect(() => {
    if (settings?.preference__user_level) {
      setValue(
        options.find(
          (option) => option.value === settings.preference__user_level
        ) as SelectOption
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings])

  return (
    <AdvancedSelect<SelectOption>
      value={value}
      label={label}
      name="userlevel"
      id="userlevel"
      options={options}
      onChange={(v: SelectOption | null) => {
        if (v && v.value !== value?.value) {
          setValue(v)
          if (updateSettings) {
            updateSettings({
              preference__user_level: v.value,
            })
          }
        }
      }}
      isDisabled={isLoading}
      isLoading={isLoading}
    />
  )
}

export default UserlevelSelector
